import { Injectable } from '@angular/core';
import { WindowRefService } from '../window/window-ref.service';
import { LoggerService } from '../logger';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private _window: any;
  private _initialized: boolean;

  constructor(
    private _windowRefService: WindowRefService,
    private _loggerService: LoggerService
  ) {
    this._window = _windowRefService.nativeWindow;
  }

  init(raygunAPIKey: string, debugMode: boolean, version: string) {
    if (raygunAPIKey) {
      const raygunFields = {
        apiKey: raygunAPIKey,
        enableCrashReporting: true,
        groupingKey: this._groupingKey.bind(this),
        options: {
          debugMode,
          ignore3rdPartyErrors: true,
        },
        setVersion: version,
      };
      Object.keys(raygunFields).forEach((key) => {
        this._window.rg4js(key, raygunFields[key]);
      });

      this._initialized = true;
    }
  }

  alertSystem(error: Error, customData?: any) {
    if (this._initialized) {
      this._loggerService.logError(error);

      try {
        this._window.rg4js('send', {
          error,
          customData: {
            ...customData,
          },
        });
      } catch (error) {
        // To catch third party cross origin script errors
        throw error;
      }
    } else {
      console.error(error, customData);
    }
  }

  private _groupingKey(message, exception, options) {
    const customData = options.customData;

    if (customData && customData.customGroupingKey) {
      return customData.customGroupingKey;
    }

    return null;
  }
}
